import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  ElementRef,
  AfterViewChecked
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SharedService, SharedConstant, ManageEmpGrpService, EmtrPagination, EmtrPaginationValues } from '@ems/shared';
import { Dropdown } from 'primeng/dropdown';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { EmtrService } from '../../emtr.service';
import { RuleService } from '../../services/rule-service/rule.service';
import { RulesListComponent } from '../rules-list/rules-list.component';
import { emtrConstant } from '../../constants/emtrConstants';
import { ruleListSubHeaderDateColumns } from '../../models/rule-list-table-header';

@Component({
  selector: 'tr-rule-list-sub-header',
  templateUrl: './rule-list-sub-header.component.html'
})
export class RuleListSubHeaderComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  @Input() isHidden: boolean;
  @Input() invalidRuleNameField : boolean
  @Output() sendFilterObject: EventEmitter<any> = new EventEmitter<any>();
  @Output() setPaginator: EventEmitter<any> = new EventEmitter<any>();
  @Output() hasSpacesRulesListSubHeader: EventEmitter<any> = new EventEmitter<any>();
  ruleListSubHeaderForm: UntypedFormGroup;
  filteredRequest: any[];
  empGroupDropDownOpts = [];
  instrumentGroupDropDownOpts = [];
  orgID: any;
  sharedConstant = SharedConstant;
  businessUnit: any;
  pageObject: EmtrPagination = EmtrPaginationValues;
  currentOrgSubscription: Subscription;
  clearOrgSubscription: Subscription;
  parent: RulesListComponent;
  filterBtnDisableForTradeSymbol = false;
  filterBtnDisableForCusip = false;
  dropdownInputValue: string;
  groupPlanSearchValue: string;
  instrumentGroupSearchValue: string;
  searchInputUpdate = new Subject<any>();
  searchInstrumentGroupUpdate = new Subject<any>();
  emtrConstant = emtrConstant;
  stateVal: any;
  instrumentGroupDropdownValue: any;
  instrumentGroupId = 0;
  isInstrumentFilterOpen = false;
  isInitialListUpdated = false;
  ruleSubHeaderColumns: any[] = ruleListSubHeaderDateColumns;
  @ViewChild('dropdown') groupDropdown: Dropdown;
  @ViewChild('instdropdown') instGroupDropdown: Dropdown;
  ruleLevelSelectedOptions = [];
  updatedStatusOptions: any[] = [];
  hasValueRuleLevelViewField = true;

constructor(private fb: UntypedFormBuilder, public sharedService: SharedService, public emtrService: EmtrService, public ruleService: RuleService, @Inject('entitlementConst') public entitlementConst,
            public manageEmpGrpService: ManageEmpGrpService, public el:ElementRef) { }

  ngOnInit() {
    this.ruleListSubHeaderForm = this.fb.group({
      tradeSymbol: '',
      cusipSymbol: '',
      empGroupName: '',
      instrumentGroupId: '',
      ruleLevel: [''],
      showRecords: this.emtrConstant.showRecords[0]
    });

    /* Set 'Active' as default value for Show Records dropdown */
    const showRecorValue = this.emtrConstant.showRecords[0];
    this.ruleListSubHeaderForm.get('showRecords').setValue(showRecorValue);
    this.instrumentGroupDropdownValue ='All';

    this.stateVal = this.sharedService.getStateVal();
    this.currentOrgSubscription = this.emtrService.clientInformation.subscribe(clientInfo => {
      if (clientInfo) {
        this.clearFilterForm();
        this.groupPlanSearchValue = '';
        this.instrumentGroupSearchValue = '';
        this.dropdownInputValue = '';
        this.orgID = clientInfo && clientInfo.orgId;
        this.businessUnit = clientInfo && clientInfo.businessUnit;
        this.pageObject.pageNo = 0;
        this.pageObject.pageSize = 15;
        this.pageObject.sortField = ['name,asc'];
        this.filterRequest();
        const param = {
          paramObj: this.pageObject,
          groupName: ''
        };
        if (this.orgID !== 0 && this.ruleService.isSubHeaderFlag === true) {
          this.ruleService.isSubHeaderFlag = false;
        }
      }
    });
    if (this.businessUnit === 'RBS' || this.businessUnit === '') {
      this.emtrConstant.ruleFilter.ruleLevel.forEach((item) => this.ruleLevelSelectedOptions.push(item.value));
      this.updatedStatusOptions = [...this.ruleLevelSelectedOptions];
      this.emtrConstant.ruleFilter.ruleLevel
        .sort((a, b) => a.value.localeCompare(b.value))
        .map(item => item.value);
      this.ruleLevelOptionsFilters();
    }
    if (this.stateVal && this.stateVal.filterObj) {
      this.updateFormValue();
    }
    this.formValueChanges();
    this.ruleService.filterClickedSubHeader.subscribe(value => {
      if (value === true) {
        this.updateGroupOrPlanName();
      }
    });
    /* To clear the ruleListSubHeaderForm when clearAll button is clicked */
    this.ruleService.clearClicked
      .subscribe(value => {
      if (value === true) {
        this.dropdownInputValue = '';
        this.ruleService.hasGroupPlanValue.emit(false);
        this.ruleService.hasValueViewField.emit(false);
        this.ruleService.hasValueCusipField.emit(false);
        this.ruleService.hasValueTradeSymbolField.emit(false);
        this.ruleService.hasInstrumentGroupValue.emit(false);
        this.clearFilterForm();
      }
    });
    }
  hideOptions() {
    this.isInstrumentFilterOpen = false;
  }

  enterFilterValue(): void {
    this.ruleListSubHeaderForm.get('empGroupName').setValue(this.dropdownInputValue ? this.dropdownInputValue : 'All');
    this.ruleListSubHeaderForm.get('instrumentGroupId').setValue(this.instrumentGroupId ? this.instrumentGroupId : 0);
    const localUpdatedFormValues = this.ruleListSubHeaderForm.getRawValue();
    this.setPaginator.emit(true);
    this.sendFilterObject.emit({
      ruleListSubHeaderForm: localUpdatedFormValues
    });
  }

  filterRequest(): void {
    this.filteredRequest = [];
    /* Rule-sub-header for SPS and DBS without IGA access should not contain Rule Level and Instrument Group fields */
    if (this.businessUnit === this.sharedConstant.spsBUText || (this.businessUnit === this.sharedConstant.dbsBUText && !this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid, '', ''))) {
      this.filteredRequest = this.ruleSubHeaderColumns.filter(item => (item.field !== 'ruleLevel' && item.field !== 'instrumentGroup'));
    } else if (this.businessUnit === this.sharedConstant.dbsBUText && this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid, '', '')) {
      /* Rule-sub-header for DBS with IGA access should not contain Rule Level and Instrument Group fields */
      this.filteredRequest = this.ruleSubHeaderColumns.filter(item => (item.field !== 'ruleLevel'));
    } else if (this.businessUnit === this.sharedConstant.rbsBUText || this.businessUnit === '') {
      /* Rule-sub-header for RBS will contain all the fields */
      this.filteredRequest = this.ruleSubHeaderColumns;
    }
  }

  clearFilterForm(): void {
    this.ruleListSubHeaderForm.reset();
    this.ruleListSubHeaderForm.patchValue({ruleLevel: this.updatedStatusOptions});
    this.ruleListSubHeaderForm.get('showRecords').setValue(this.emtrConstant.showRecords[0]);
    this.dropdownInputValue = 'All';
    this.instrumentGroupDropdownValue = 0;
  }

  getEmployeeGroupList(param) {
    const filterObj = {orgId : this.orgID, groupName: param.groupName, active: true};
    this.manageEmpGrpService.getEmployeeGrpOrPlanList(param.paramObj, filterObj).subscribe((value: any) => {
      this.empGroupDropDownOpts = [];
      this.empGroupDropDownOpts.unshift({label: this.sharedConstant.groupNameAll, value: this.sharedConstant.groupNameAll});
      value.data.content.forEach(empGroupName => {
        const data = {label: empGroupName.name, value: empGroupName.name};
        this.empGroupDropDownOpts.push(data);
      });
      this.ruleListSubHeaderForm.get('empGroupName').setValue(this.empGroupDropDownOpts[0].value);
    });
  }

  ngOnDestroy(): void {
    if (this.currentOrgSubscription) {
      this.currentOrgSubscription.unsubscribe();
    }
    if (this.clearOrgSubscription) {
      this.clearOrgSubscription.unsubscribe();
    }
    this.ruleService.clearClicked.emit(false);
  }

  searchedText(event, data) {
    if (data === this.sharedConstant.groupName) {
      this.groupPlanSearchValue = event.target.value;
      this.searchInputUpdate.next(this.groupPlanSearchValue);
    } else if (data === this.sharedConstant.instrumentGroup) {
      this.instrumentGroupSearchValue = event.target.value;
      this.searchInstrumentGroupUpdate.next(this.instrumentGroupSearchValue);
    }
  }

  clearSearch(dropdown: Dropdown) {
    if (!this.groupPlanSearchValue) {
      dropdown.resetFilter();
    }
  }
  clearInstrumentSearch(dropdown: Dropdown) {
    if (!this.instrumentGroupSearchValue) {
      dropdown.resetFilter();
    }
    this.isInstrumentFilterOpen = true;
  }

  groupNameUpdated(event?) {
    const selectedValue = event?.selectedItem;
    this.ruleListSubHeaderForm.get('empGroupName').setValue(selectedValue !== 'All' ? selectedValue : '');
    this.dropdownInputValue = selectedValue;
    if (selectedValue && selectedValue !== 'All') {
      this.ruleService.hasGroupPlanValue.emit(true);
    } else {
      this.ruleService.hasGroupPlanValue.emit(false);
    }
  }
  instrumentGroupNameUpdated($event) {
    this.instrumentGroupId = this.instrumentGroupDropdownValue = $event.selectedItem;
    this.ruleListSubHeaderForm.get('instrumentGroupId').setValue(this.instrumentGroupDropdownValue ? this.instrumentGroupDropdownValue : 0);
    if (this.instrumentGroupDropdownValue || this.instrumentGroupId !== 0) {
      this.ruleService.hasInstrumentGroupValue.emit(true);
    } else {
      this.ruleService.hasInstrumentGroupValue.emit(false);
    }
  }

  updateGroupOrPlanName() {
    const name = this.sharedService.selectedGroupOrPlanName ? this.sharedService.selectedGroupOrPlanName : this.dropdownInputValue ? this.dropdownInputValue : 'All';
    const instrumentGroupId = this.instrumentGroupId ? this.instrumentGroupId : 0;
    this.ruleListSubHeaderForm.get('empGroupName').setValue(name);
    this.ruleListSubHeaderForm.get('instrumentGroupId').setValue(instrumentGroupId);
    const localUpdatedFormValues = this.ruleListSubHeaderForm.getRawValue();
    this.sendFilterObject.emit({
      ruleListSubHeaderForm: localUpdatedFormValues,
      filterBtnDisableForTradeSymbol: this.filterBtnDisableForTradeSymbol,
      filterBtnDisableForCusip: this.filterBtnDisableForCusip
    });
  }

  ngAfterViewInit() {
    /*Set the default values in filter section*/
    if(!this.sharedService.selectedGroupOrPlanName){
      this.dropdownInputValue = 'All';
    }
    else{
      this.dropdownInputValue = this.sharedService.selectedGroupOrPlanName;
      this.sharedService.selectedGroupOrPlanName = '';
    }
   
    this.instrumentGroupDropdownValue = 0;
  }

  ngAfterViewChecked(): void {
    const elementRefStatus = this.el.nativeElement.querySelectorAll('.p-multiselect-label')[0];
    this.sharedService.setMultiSelectDefaultLabel(elementRefStatus, this.ruleListSubHeaderForm, 'ruleLevel', this.ruleLevelSelectedOptions.length);
  }

  updateFormValue() {
     this.stateVal = this.sharedService.getStateVal();
    const showRecordLabel = this.stateVal.filterObj.active ? 'Active' : 'Deleted';
    this.ruleListSubHeaderForm.patchValue({
      tradeSymbol: this.stateVal.filterObj.symbol,
      cusipSymbol: this.stateVal.filterObj.cusip,
      empGroupName: this.stateVal.filterObj.groupName,
      instrumentGroupId: this.stateVal.filterObj.instrumentGroupId,
      ruleLevel : this.stateVal.filterObj.ruleLevel,
      showRecords: {value: this.stateVal.filterObj.active, label: showRecordLabel}
    });
    this.disableOrEnableShowRecord(this.stateVal.filterObj.ruleLevel);
  }

  disableOrEnableShowRecord(value) {
    if (value) {
      if (!this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageInstruments.uuid, '', '') &&
         value.length === 1  && value[0].value == 'Client'
      ) {
        this.ruleListSubHeaderForm.get('showRecords').setValue(this.emtrConstant.showRecords[0]);
        this.ruleListSubHeaderForm.get('showRecords').disable();
      } else {
        this.ruleListSubHeaderForm.get('showRecords').enable();
      }
    }
  }

  formValueChanges() {
    this.ruleListSubHeaderForm.get('tradeSymbol').valueChanges.subscribe(value => {
      if (this.ruleListSubHeaderForm.get('tradeSymbol').errors?.emsStartSpacePattern !== false) {
        /* special character validation */
        if (value && this.ruleListSubHeaderForm.get('tradeSymbol').invalid) {
          this.ruleService.invalidTradeSymbolField.emit(true);
        } else {
          this.ruleService.invalidTradeSymbolField.emit(false);
        }
        /* clear button disable */
        if (value && value.length > 0) {
          this.ruleService.hasValueTradeSymbolField.emit(true);
        }
        this.hasSpacesRulesListSubHeader.emit(false);
      } else {
        this.hasSpacesRulesListSubHeader.emit(true);
      }
    });

    this.ruleListSubHeaderForm.get('cusipSymbol').valueChanges.subscribe(value => {
      if (this.ruleListSubHeaderForm.get('cusipSymbol').errors?.emsStartSpacePattern !== false) {
        this.filterBtnDisableForCusip = this.sharedService.isValueLengthLessThan9(value);
        /* showing validation message in parent */
        if (this.filterBtnDisableForCusip) {
          this.ruleService.invalidCusipSymbolField.emit(true);
        } else {
          this.ruleService.invalidCusipSymbolField.emit(false);
        }

        if (this.ruleListSubHeaderForm.get('cusipSymbol').invalid) {
          this.ruleService.specialCharValidation.emit(true);
        } else {
          this.ruleService.specialCharValidation.emit(false);
        }
        this.hasSpacesRulesListSubHeader.emit(false);
      } else {
        this.hasSpacesRulesListSubHeader.emit(true);
      }

      /* clear button disable and input value not more than 9 digits. */
      if (value && value.length > 0) {
        this.ruleService.hasValueCusipField.emit(true);
      }
    });

    if (this.businessUnit === 'RBS' || this.businessUnit === '') { // Prevent infinite loop if ruleLevel is null for DBS and SPS
      this.ruleListSubHeaderForm.get('ruleLevel').valueChanges.subscribe(value => {
        if (value && !this.hasValueRuleLevelViewField) {
          this.ruleService.hasValueViewField.emit(true);
          this.disableOrEnableShowRecord(value);
        }
        if (value && value.length === 0) {
          setTimeout(() => {
            this.ruleListSubHeaderForm.patchValue({ ruleLevel: this.businessUnit ? this.ruleLevelSelectedOptions : this.updatedStatusOptions });
          });
        }
        this.hasValueRuleLevelViewField = false;
      });
    }

    this.ruleListSubHeaderForm.get('showRecords').valueChanges.subscribe(value => {
      if (value) {
        this.ruleService.hasValueViewField.emit(true);
      }
    });
  }

  ruleLevelOptionsFilters() {
    setTimeout(() => {
      const ruleLevel = this.stateVal?.filterObj?.ruleLevel;
      // to remove client option from ruleLevl dropdown for All selected
      if (this.businessUnit === '') {
        this.updatedStatusOptions = this.updatedStatusOptions.filter(option => option !== 'Client');
      }
      this.ruleListSubHeaderForm.patchValue({
        ruleLevel: ruleLevel && ruleLevel[0] !== 'All' ? ruleLevel : this.updatedStatusOptions
      });
    }, 10);
  }
  
  isOptionDisabled(option: any): boolean {
    return option.label === 'Client';
  }
}
